import { useEffect } from 'react';

import { useAccountActions } from './AccountContext';

import { getCurrentUserAccount } from './restApi';

const AccountLoader = ({ stripePublishableKey }) => {
  const { initializeState, onResponse, onError } = useAccountActions();

  useEffect(() => {
    initializeState({ stripePublishableKey });
  }, []);

  useEffect(() => {
    getCurrentUserAccount({
      onResponse,
      onError,
    });
  }, []);

  return null;
};

export default AccountLoader;